'use client';
import React from 'react';
import dynamic from 'next/dynamic';

interface FearGreedGaugeProps {
  value: number;
  label: string;
}

const FearGreedGaugeInner = dynamic(
  () => import('./FearGreedGaugeInner'),
  {
    ssr: false,
    loading: () => (
      <div className="w-[120px] h-[80px] animate-pulse bg-muted rounded" />
    ),
  }
);

export default function FearGreedGauge({ value, label }: FearGreedGaugeProps) {
  return <FearGreedGaugeInner value={value} label={label} />;
}